import React from "react";
import styles from "./index.module.scss";
import { timeAgo } from "../../../../../../utils/utils";
import { useToast } from "../../../../toast/toast";
import { useDeleteNotes } from "../../../../../../hooks/react-query/investor-dashboard/useDeleteNotes";
import AddNotesDialog from "../../../../../../pages/calling-pipeline/add-notes";
import DeleteNotesDialog from "../../../../../../pages/calling-pipeline/delete-notes";

export default function ItemHeader({ item, showActions = false, status }: any) {
  const userObj = localStorage.getItem("user-detail");
  const userDetail = userObj && JSON.parse(userObj ?? "");
  const { showSuccess }: any = useToast();
  const [visible, setVisibleNotes] = React.useState(false);
  const [visibleDeleteNotes, setVisibleDeleteNotes] = React.useState(false);
  const deleteNotesMutation = useDeleteNotes(
    (data) => {
      showSuccess("success", "Notes Deleted Successfully.");
      console.log("data", data);
    },
    (error) => {
      console.log("error", error);
    }
  );

  return (
    <div className={styles.itemHeaderWrap}>
      <div className={styles.itemHeader}>
        <div className={styles.userBox}>
          <span className={styles.timelineUser}>
            {item?.fullname || userDetail.name}
          </span>{" "}
          <span className={styles.timelineStatusChanged}>{status}</span>
          {status === "Call-Recorded" && (
            <span className={styles.timelineUser}>Call Details</span>
          )}
          <span className={styles.dot}>•</span>
          <span className={styles.timelineAgo}>
            {timeAgo(item?.createdAt || item?.createdat)}
          </span>
        </div>
      </div>
      {showActions && (
        <span className={styles.actions}>
          <img
            src="/images/edit.svg"
            alt=""
            onClick={() => setVisibleNotes(true)}
          />
          <img
            src="/images/delete.svg"
            alt=""
            onClick={() => setVisibleDeleteNotes(true)}
          />
        </span>
      )}
      <DeleteNotesDialog
        visible={visibleDeleteNotes}
        setVisible={setVisibleDeleteNotes}
        item={item}
      />
      <AddNotesDialog
        visible={visible}
        setVisible={setVisibleNotes}
        placeholder="Write notes..."
        heading="Edit Notes"
        accountId={item?.accountId}
        propertyId={item?.pubPropertyId}
        isEdit={true}
        item={item}
      />
    </div>
  );
}
